import {FC, ReactNode} from 'react';
import styled from 'styled-components';

const Container = styled.div<TProps>`
    display: grid;
    grid-template-columns: repeat(${props => props.$itemsPerRow}, 1fr);

    @media (max-width: 1024px) {
        ${props => props.$itemsPerRowTablet !== undefined && `
            grid-template-columns: repeat(${props.$itemsPerRowTablet}, 1fr);
        `}
    }

    @media (max-width: 768px) {
        ${props => props.$itemsPerRowMobile !== undefined && `
            grid-template-columns: repeat(${props.$itemsPerRowMobile}, 1fr);
        `}
    }
`;

type TProps = {
    $itemsPerRow: number;
    $itemsPerRowTablet?: number;
    $itemsPerRowMobile?: number;
    columnGapClass?: string;
    rowGapClass?: string;
    children: ReactNode;
}

const GridCollection: FC<TProps> = ({$itemsPerRow, $itemsPerRowTablet, $itemsPerRowMobile, columnGapClass, rowGapClass, children}) => {
    return (
        <Container $itemsPerRow={$itemsPerRow}
                   $itemsPerRowTablet={$itemsPerRowTablet ?? undefined}
                   $itemsPerRowMobile={$itemsPerRowMobile ?? undefined}
                   className={`${columnGapClass ?? 'cr-column-gap-lg'} ${rowGapClass ?? 'cr-row-gap-xl'}`}
        >
            {children}
        </Container>
    );
}

export default GridCollection;
